import React from 'react';
import Loader from 'react-loader-spinner';
import { theme } from '../../theme';

type LoaderType =
    | 'TailSpin'
    | 'Audio'
    | 'BallTriangle'
    | 'Bars'
    | 'Circles'
    | 'Grid'
    | 'Hearts'
    | 'Oval'
    | 'Puff'
    | 'Rings'
    | 'ThreeDots'
    | 'Watch'
    | 'RevolvingDot'
    | 'Triangle'
    | 'Plane'
    | 'MutatingDots'
    | 'CradleLoader';

interface IBILoaderProps {
    height?: any;
    width?: any;
    color?: string;
    type?: LoaderType;
    timeout?: number;
}
export default function IBILoader({
    color = theme.primary.THEME,
    height = 100,
    width = 100,
    timeout,
    type = 'TailSpin'
}: IBILoaderProps) {
    return (
        <div className={'d-flex align-items-center justify-content-center w-100 flex-grow-1'}>
            <Loader type={type} color={color} height={height} width={width} timeout={timeout} />
        </div>
    );
}
